<template>
    <div class="centerXY loading-box" :style="{height: `${height ? height + 'px' : '100%'}`, fontSize: `${fontSize}px`}">
        <v-progress-circular
            indeterminate
            width="3"
            color="#0052CC"
            class="mr-10"
            :style="{width: `${sizeLoading}px`}"
        ></v-progress-circular>
        {{$f.tc('loadingData')}}
    </div>
</template>
<script>
export default {
    name: 'LoadingBox',
    props: {
        height: Number,
        fontSize: {
            type: Number,
            default: 14
        },
        sizeLoading: {
            type: Number,
            default: 24
        }
    }
}
</script>
<style lang="scss" scoped>
.loading-box {
    width: 100%;
    background: #f7f9fa;
    font-family: 'open sans';
    font-size: 14px;
}
</style>
